import { palette, heading, paragraph, fonts, chart, assets, shadows, gradients, radials, uniques, } from "./palette";
import type { Theme, Strata, ThemePalette, } from "@bracket/ui/types";



export const light: Theme = {
	name: "light",
	assets,
	fonts,
	typeface: {
		p: paragraph,
		...heading,
	},
	chart,
	shadows,
	gradients,
	radials,
	...palette,
	uniques,
	// @ts-expect-error - TODO: fix this
	strata: function ( level?: Strata ) {
		const key = level ? level === "default" ? "surface_container" : `surface_container_${level}` : "surface_container";
		return key in this ? this[key as keyof ThemePalette] : this.surface_container;
	},
	unique: function ( key: string, ) {
		return uniques[key as keyof typeof uniques] || {};
	}
};
